interface DropdownChevronIconProps {
  color?: string;
  width?: number;
  height?: number;
}

/**
 * Shared dropdown chevron icon, matching the designer's kuika-selectbox chevron
 * (arrows/chevron-down.svg). Used as the `suffixIcon` for selectbox-style
 * components so every dropdown arrow looks identical across the app.
 */
export const DropdownChevronIcon = ({
  color = "#606F85",
  width = 14,
  height = 14
}: DropdownChevronIconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path d="M4 6L8 10L12 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
